/**
 * Detects if the given text is likely RTL (right-to-left).
 * Covers languages such as Arabic, Hebrew, Persian, and Urdu.
 *
 * @param text - The text to analyze. Defaults to an empty string.
 * @returns `true` if the text contains RTL characters, otherwise `false`.
 */
export function isRtlLanguage(text: string = ''): boolean {
	const rtlCharRanges = [
		'\u0590-\u05FF', // Hebrew
		'\u0600-\u06FF', // Arabic
		'\u0750-\u077F', // Arabic Supplement
		'\u08A0-\u08FF', // Arabic Extended-A
		'\uFB50-\uFDFF', // Arabic Presentation Forms-A
		'\uFE70-\uFEFF', // Arabic Presentation Forms-B
		'\u0700-\u074F', // Syriac
	];

	const rtlRegex = new RegExp(`[${rtlCharRanges.join('')}]`);
	return rtlRegex.test(text);
}
